<template>
  <div v-if="openingHoursChat.operatingChat"
    v-bind:class="(mensagem.author === 'Atendente') ? 'attend-messege-montreal' : 'client-messege-montreal'"
    v-bind:style="[(mensagem.author === 'Eu') ? {backgroundColor: primary_color} : '']"
  >
 
    <!-- <strong> {{ mensagem.author }}: </strong>
    <br> -->
    <span v-if="mensagem.type === 'text'" v-html="mensagem.message.replace(/(?:\r\n|\r|\n)/g, '<br>')">
    </span>
    <div v-if="mensagem.type === 'file'">
      <a target="_blank" :download="mensagem.message" :href="mensagem.fileUrl">{{mensagem.message}}</a>
      <div style="margin-top: 5px" v-if="((typeof mensagem.file !== 'undefined' && mensagem.file !== '' && mensagem.file !== null) && mensagem.file.downloading === true)">
        <progress-bar :bar-color="this.secondary_color" text-fg-color="#FFF" :bar-border-radius="10" :size="5" v-bind:val="mensagem.file.progress" v-bind:text="mensagem.file.progress + '%'" v-bind:title="mensagem.file.progress  + '%'"></progress-bar>
      </div>
    </div>
    <div v-if="mensagem.hasOwnProperty('opcoes')" style="margin-top: 10px;" >
      <span v-for="(opcao, index) in mensagem.opcoes">
        <button v-if="active" @click="escolheOpcao(opcao)" :style="cssVars"  class="btn-escolher-opcoes">{{ /*(index + 1) + ' - ' +*/ opcao.titulo }}</button>
        <span v-else>{{ opcao.titulo }}<br></span>
      </span>
    </div>
  </div>
</template>
<script>
import ProgressBar from 'vue-simple-progress';

export default {
  name:"mensagem-ballon-montreal",
  components: {
    ProgressBar
  },
  props:{
    mensagem: Object,
    primary_color: String,
    secondary_color: String,
    openingHoursChat: Object
  },
  data(){
    return {
      active: true
    }
  },
  mounted() {
    // let chat_history = document.getElementById("chat-history");
    // chat_history.scrollTop = chat_history.scrollHeight
    this.$el.scrollIntoView({ behavior: "smooth" });
  },
  computed: {
    cssVars() {
      return {
        '--bg-color': this.primary_color
      }
    }
  },
  methods: {
    escolheOpcao: function(opcao){
      this.$emit('escolheOpcao', opcao.titulo);
      // document.querySelector('#message-to-send').value = opcao.titulo;
      // document.querySelector('#send-button').click();
      this.active = false;
    }
  }
}
</script>

<style lang="scss">

.btn-escolher-opcoes {
  background: var(--bg-color);
  color:white;
  border-radius: 11px;
  -webkit-border-radius: 11px;
  -moz-border-radius: 11px;
  outline: none;
  border-color: transparent;
  margin-bottom:5px;
  padding: 3px 10px;
  display: block;
  cursor: pointer;
  border-width: thin;
  font-size: 17px;

  &:hover {
    color: var(--bg-color);
    background-color: white;
    border-color: var(--bg-color);
  }
}
</style>
